/* global googletag */

MOVE.ARTICLE.Helper = (function (ARTICLE) {
  var SHOWN_DWELL_DURATION = 1000,
    SHOWN_PIXEL_PERCENT  = 0.5 - 0.0000001;

  var slugify = function (str) {
    return str.toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/(^-|-$)/g,'');
  };

  var getArticleAttribution = function(attributionObj) {
    if (attributionObj && attributionObj.sponsor_name) {
      var template = JST['templates/news_advice_article_attribution']({
        attribution: attributionObj
      });
      return template.replace(/>\s+</g,'><'); // clear whitespace between elements
    }

    return '';
  };

  var getAdSlotName = function(options) {
    if ( !options || !options.sizes || !options.adUnit ) {
      return null;
    }
    return "div-gpt-ad-" + options.adUnit;
  };

  var showDynamicAd = function(options, slotName) {
    var adUnit = window.gptAds.adsPath + options.adUnit + "/" + window.gptAds.pagePath + '/' + window.gptAds.device;

    googletag.cmd.push(function () {
      var slot = googletag.defineSlot(adUnit, options.sizes, slotName).setTargeting('pos', options.pos).addService(googletag.pubads());
      googletag.display(slotName);

      googletag.pubads().refresh([slot]);
    });
  };

  var trackAttribution = function(attribution_array) {
    // attribution_array: [{dart_core_values, third_party_url}
    if (attribution_array) {
      $.each(attribution_array, function (index, value) {
        if (value.dart_core_values) {
          MOVE.Medias.articleTracking(value.dart_core_values);
        }
      });
    }
  };

  var isValidZipCode = function(zipcode) {
    var isEmpty = _.isEmpty(zipcode),
      isValidated = /(^(?!0{5})(\d{5})(?!-?0{4})(|-\d{4})?$)/.test(zipcode);
    return (isEmpty || isValidated);
  };

  var getRecentSearch = function() {
    var recentSearch = {};
    var recentSearches = MOVE.UserActivity.getSortedRecentSearches();
    var lastSearchQuery = recentSearches && recentSearches[0] ? recentSearches[0].query : {};
    if (lastSearchQuery.postal_code) {
      recentSearch = {
        type: 'postal_code',
        postal_code: lastSearchQuery.postal_code
      }
    }
    else if(lastSearchQuery.city) {
      recentSearch = {
        type: 'city',
        city: lastSearchQuery.city,
        state: lastSearchQuery.state_code
      }
    }
    return recentSearch;
  };

  /**
   * When the visibility changes (scrolls, resizes, content loaded), check to see
   * whether slots are visible and fire off a shown event if they are.
   * @param slots
   * @param vidoraAPI
   * @param widget
   * @returns {Function}
   */
  var createVisibilityChangeHandler = function(slots, vidoraAPI, widget) {
    return function() {
      for (var i = 0; i < slots.length; i++) {
        var slot = slots[i];

        // Only send a shown event for the slot if an event hasn't already been sent and
        // it is visible.
        if (!slot.shownSent && slotIsVisible(slot)) {
          // Send the shown event only after enough time has passed where the slot is
          // still visible. Clear the timeout if no longer visible, and wait if the
          // slot already has a timeout on it.
          if (!slot.timeout) {
            // Create a handler to send the shown event, and set a timeout for it of
            // 1 second.
            var shownHandler = createSendShownEventHandler(slot, vidoraAPI, widget);
            slot.timeout = window.setTimeout(shownHandler, SHOWN_DWELL_DURATION);
          }
        }
        else if (slot.timeout) {
          // If the slot has a timeout, but is no longer visible, then just clear the
          // timeout.
          window.clearTimeout(slot.timeout);
          delete slot.timeout;
        }
      }
    };
  };

  /**
   * Create a handler for sending a shown event so we don't run into the for loop
   * closure problem where the variables aren't scoped properly.
   * @param slot
   * @param vidoraAPI
   * @param widget
   * @returns {Function}
   */
  var createSendShownEventHandler = function(slot, vidoraAPI, widget) {
    if(widget === 'hamilton') {
      return function () {
        var contentID = slot.getAttribute("data-capi-id");
        var moduleID = slot.getAttribute("data-module-id");
        var position = slot.getAttribute("data-position");
        vidoraAPI.send("shown", contentID, {
          params: {
            cookie_id: vidoraAPI.getUUID(),
            group_id: moduleID,
            position: position
          }
        });

        // Mark the slot as shown.
        slot.shownSent = true;
      };
    } else if( widget === 'top_stories' ){
      return function() {
        var contentID = slot.getAttribute("data-capi-id");
        vidoraAPI.send("shown", contentID, {
          params: {
            cookie_id: vidoraAPI.getUUID()
          },
          _params: {
            api_key: "move.A0A98B2C430073BEF663E19D1EB8BA14"
          }
        });

        // Mark the slot as shown.
        slot.shownSent = true;
      };
    }
  };

  /**
   * Returns whether the slot is visible on the page by checking first whether the
   * document is hidden and then checking whether the element is in the viewport.
   * @param slot
   * @returns {boolean|*}
   */
  var slotIsVisible = function(slot) {
    return (!document.hidden && isElementInViewport(slot));
  };

  /**
   * Determine if an element is within the viewport by calculating the area of overlap
   * between the rectangle defined by the window viewport and element's bounding
   * rectangle relative to the viewport.
   *
   * The element is considered visible if at least a percent of the area is
   * visibile within the viewport, or if larger than the viewport, at least
   * a percent of the viewport contains the item.
   * @param htmlElement
   * @returns {boolean}
   */
  var isElementInViewport = function(htmlElement) {
    var rect = htmlElement.getBoundingClientRect();
    var elementArea = rect.width * rect.height;
    var viewportWidth = window.innerWidth;
    var viewportHeight = window.innerHeight;
    var viewportArea = viewportWidth * viewportHeight;
    var overlapX = calculateOverlap(0, viewportWidth, rect.left, rect.right);
    var overlapY = calculateOverlap(0, viewportHeight, rect.top, rect.bottom);
    var overlapArea = overlapX * overlapY;

    return overlapArea > SHOWN_PIXEL_PERCENT * Math.min(elementArea, viewportArea);
  };

  /**
   * Helper function to calculate the overlap between two intervals. Returns 0 if no overlap.
   * @param min0
   * @param max0
   * @param min1
   * @param max1
   * @returns {number}
   */
  var calculateOverlap = function(min0, max0, min1, max1) {
    return Math.max(0, Math.min(max0, max1) - Math.max(min0, min1));
  };

  var isDesktop = function() {
    return MOVE.Helper.detectViewPort() === 'medium' || MOVE.Helper.detectViewPort() === 'large';
  };

  var largeThumbnail = function (imageSrc) {
    if (!_.isString(imageSrc)) {
      return null;
    }

    return imageSrc.replace('xd-w640_h480_q80', 'xd-w300_h169_q80');
  };

  ARTICLE.Helper = {
    slugify: slugify,
    getArticleAttribution: getArticleAttribution,
    trackAttribution: trackAttribution,
    showDynamicAd: showDynamicAd,
    getAdSlotName: getAdSlotName,
    isValidZipCode: isValidZipCode,
    getRecentSearch: getRecentSearch,
    createVisibilityChangeHandler: createVisibilityChangeHandler,
    isDesktop: isDesktop,
    largeThumbnail: largeThumbnail
  };

  return ARTICLE.Helper;
})(MOVE.ARTICLE || {});



// WEBPACK FOOTER //
// ./news_and_advice/shared/helper.js